import { Card } from 'antd'
import React from 'react'
import PageHeading from '../../../components/common/PageHeading'
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

const MarketingRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Activate Premium Leads ", "1", "", "", ""),
  ]),
  RightBarMethod("Reports", "t2", <i className="fa-solid fa-chart-column"></i>, [
    RightBarMethod("Guest Card Interests", "2", "", "", ""),
    RightBarMethod("Guest Card Inquiries", "3", "", "", ""),
    RightBarMethod("Prospect Source Tracking", "4", "", "", ""),
    RightBarMethod("Owner Leasing", "5", "", "", ""),
    RightBarMethod("Premium Leads Billing Detail", "6", "", "", ""),
    RightBarMethod("Leasing Agent Performance", "7", "", "", ""),
  ]),
  RightBarMethod("HELP TOPICS", "t4",<i className="fa-solid fa-circle-question"></i>, [
    RightBarMethod("Track Live Vacancy Postings", "8", "", "", ""),
    RightBarMethod("Post & Unpost Vacancies", "9", "", "", ""),
    RightBarMethod("Complete Vacancy Marketing Information", "10", "", "", ""),
    RightBarMethod("Premium Leads", "11", "", "", ""),
  ]),
]

const Marketing = () => {
  return (
    <div>
        <PageHeading heading="Marketing"/>
        <Card
    title="Where is my property listed?"
    bordered={false}
  >
    <p>No units or campaigns are posted to the internet on this property. Visit the vacancies page or a unit page to post to internet and check here to see where you're listed.</p>
  </Card>

  <div className="RightSidebar">
        <RightBar RightBarData={MarketingRightBar} />
      </div>
    </div>
  )
}

export default Marketing